import { createSlice } from "@reduxjs/toolkit";

const initialValues = {
  multiStructureSelection: "",
};

export const newStructureSlice = createSlice({
  name: "newStructure",
  initialState: initialValues,
  reducers: {
    multiStructure: (state, action) => {
      state.multiStructureSelection = action.payload;
    },
  },
});

export const { multiStructure } = newStructureSlice.actions;

export default newStructureSlice.reducer;
